// Reading the CSRF token (ADR-0049) from the page.
//
// The token itself lives in one place only: the <meta name="csrf-token"> tag
// that partials/_csrf_meta.html renders into every base template. This module
// is the bundle's reader of that tag; the two callers that cannot import from
// the bundle - static/js/settings.js (a classic script) and the inline
// reporter in partials/_error_reporter.html (which must survive a broken
// bundle) - repeat the same one-line lookup on purpose. What they duplicate is
// a DOM query, not a value, so there is nothing that can drift apart.

export function getCsrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
}

// Header name, not a form field: every caller in this codebase sends JSON or
// FormData through axios/fetch, and a header needs no cooperation from the
// body. Flask-WTF accepts X-CSRFToken out of the box.
export function csrfHeaders(extra = {}) {
    return Object.assign({}, extra, { 'X-CSRFToken': getCsrfToken() });
}
